module.exports = __webpack_public_path__ + "static/media/DSCF9611-2.4dc14347.jpg";